type TSubsection = {
  number: string
  content: string
  subsections?: TSubsection[]
}

type TTermsAndCondition = {
  section: string
  subsections: TSubsection[]
}

const termsAndCondition: TTermsAndCondition[] = [
  {
    section: 'User Statement',
    subsections: [
      {
        number: '1.1',
        content:
          'By ticking “I understand” when using the Website or participating in our study, the User is deemed to have read, understood, and agreed to all contents in the Terms & Conditions.',
      },
      {
        number: '1.2',
        content:
          'Terms & Conditions constitute a valid agreement between the User and Us. If the User does not agree to one, part, or all of the contents of the Terms & Conditions, then the User is not allowed to use the services on the Websites.',
      },
      {
        number: '1.3',
        content:
          'User who is below 18 (eighteen) years old asserts and warrants that they have obtained approval from their parents or legal guardian to agree to this Terms & Conditions and Privacy Policy.',
      },
      {
        number: '1.4',
        content:
          "We reserve the right, at any time and from time to time, to change and/or replace these Terms & Conditions in whole or in part, without prior notice to the User. The User who continues to use Our services is considered a sign of affirmative acknowledgment of any modifications and a sign of the User's agreement to remain bound by the amended and/or replaced Terms and Conditions. The User is expected to check this page from time to time for changes that we have made, as they are binding on the User.",
      },
      {
        number: '1.5',
        content:
          'Access to the services on Website is provided "as is", and the use of Website is at the User\'s own risk. To the extent permitted by law:',
        subsections: [
          {
            number: '1.5.1',
            content:
              'We expressly exclude all terms, warranties, and other conditions which may not be statutory, not in accordance with the common law, or otherwise.',
          },
          {
            number: '1.5.2',
            content:
              'We expressly exclude liability for indirect or consequential loss or damage incurred by the User in connection with Our services or with the use, inability to use, or results of using our services, whatever the cause.',
          },
        ],
      },
    ],
  },
  {
    section: 'Participation',
    subsections: [
      {
        number: '2.1',
        content:
          'To be able to participate in surveys, the User must be 18 (eighteen) years old minimum and is required to complete the information required to start survey.',
      },
      {
        number: '2.2',
        content:
          'Account and password confidentiality and activities of an account are the personal responsibility of the owner of the account. We are not responsible for any activities carried out by an account, except for those carried out by Us and directly impact the account owner.',
      },
      {
        number: '2.3',
        content:
          'Email and mobile number may only be used 1 (one) time for the Website onboarding process.',
      },
      {
        number: '2.4',
        content:
          "User is only allowed to use 1 (one) account in the Our service, even though the User uses a different email and/or mobile number in the account registration process. If it is found that more than 1 (one) account has been created by 1 (one) User, We have the right to terminate the User's account.",
      },
      {
        number: '2.5',
        content:
          "User who wishes to use Our services must provide Us with correct, accurate, up-to-date, and complete personal data information. If the User does not provide valid, accurate, reliable, and complete personal data information to Us, then We have the right to terminate the User's access and account.",
      },
      {
        number: '2.6',
        content:
          'Access to Our services is permitted for a limited time, and We may withdraw or modify the service without prior notice. We will not be responsible if - for some reason - the Our service is unavailable at any time or every period.',
      },
      {
        number: '2.7',
        content:
          'We may restrict or shut off certain parts of Our service to the Users,  especially to the Users who are below 18 (eigtheen) years old.',
      },
    ],
  },
  {
    section: 'Study',
    subsections: [
      {
        number: '3.1',
        content:
          'User will be sent an email and/or notification that contains an invitation to participate in a study or information via the Website or directly by us',
      },
      {
        number: '3.2',
        content:
          "We have the right to determine the target participants in a study to certain users according to the study's criteria.",
      },
      {
        number: '3.3',
        content: 'User is only entitled to take studies provided and invited directly by us.',
      },
      {
        number: '3.4',
        content:
          'Studies may be terminated directly by us, and we reserve the right not to reward User who has completed such studies.',
      },
      {
        number: '3.5',
        content:
          'We reserve the right to disqualify an answer from a User if it does not meet the specifications of a study, and the User will not be rewarded.',
      },
      {
        number: '3.6',
        content:
          'We have the right to disqualify the answer from the User if it is found there are allegations of cheating and/or violations in participating in and/or answering a study provided by us.',
      },
      {
        number: '3.7',
        content:
          'We have the right to disqualify answers from User who has participated in and answered a study that is no longer valid or outside the time limit set by us.',
      },
      {
        number: '3.8',
        content:
          'User will not be able to participate in the same survey and their submission will be auto-disqualified if a User exits when in the middle of participating in a survey.',
      },
      {
        number: '3.9',
        content: 'User is not allowed to participate in/repeat the same study without our consent.',
      },
      {
        number: '3.10',
        content:
          'All studies that have been run or created through the Website will be stored by us. We reserve the right to analyze the study.',
      },
      {
        number: '3.11',
        content:
          'User understands that some studies may contain future plans or have economy value research of a brand or company, hence User agrees that all the studies they participate in confidential and must not disseminate any questions they obtain from the studies.',
      },
    ],
  },
  {
    section: 'Information Data',
    subsections: [
      {
        number: '4.1',
        content:
          'The User agrees that we have the right to store and use all information and data provided to us or generated from reports made by us. Such information and data may be used for analysis and marketing purposes carried out by us.',
      },
      {
        number: '4.2',
        content:
          'The User agrees that we can analyze and present User information and data, as well as the results of studies that have been carried out by us. The User also agrees that we can process such information and data to make reports for parties that work with us.',
      },
      {
        number: '4.3',
        content:
          "We guarantee user information and data confidentiality, including name, email, address, and mobile number. We will not provide User information and data to parties who cooperate with us without the User's consent, but we will identify Users anonymously to parties working with us.",
      },
      {
        number: '4.4',
        content:
          'Our service allows Users to load sites or references to information, content, and services that third parties have provided. We are not responsible for User information and data sent and stored by third parties.',
      },
    ],
  },
  {
    section: 'Rewards and Withdrawals',
    subsections: [
      {
        number: '5.1',
        content:
          'The User will be given a balance in the form of Rewards if the User participates in Our study and We have approved the answer.',
      },
      {
        number: '5.2',
        content: 'The balance is only given to Users who have an account on the Website',
      },
      {
        number: '5.3',
        content:
          "We have the right to reduce the User's balance if fraud, duplication, and inaccuracies are found in the study that the User participates in.",
      },
      {
        number: '5.4',
        content:
          'Withdrawals between banks will be processed within a maximum of 3 x 24 hours working days.',
      },
      {
        number: '5.5',
        content:
          'If an alleged violation of the Terms and Conditions, fraud, and crime is found, We have the right to postpone and/or cancel the withdrawal of funds made by the User.',
      },
    ],
  },
  {
    section: 'Account Deletion',
    subsections: [
      {
        number: '6.1',
        content:
          "The User agrees that We have the right to eliminate User's account access if alleged violation of the Terms and Condition is found.",
      },
      {
        number: '6.2',
        content:
          "We have the right to eliminate access to the Website and/or terminate the account of a User who has an alleged violation of the Terms and Conditions. If the User's account is deleted by us, the User's balance is considered invalid and cannot be withdrawn or withdrawn by the User.",
      },
      {
        number: '6.3',
        content:
          "Termination of the User's account only deletes the personal information data that has been stored in Us, but the information data provided by the User in a study will not be deleted.",
      },
    ],
  },
  {
    section: 'Intellectual Property Rights',
    subsections: [
      {
        number: '7.1',
        content:
          "We are the owner or licensee of all intellectual property rights in the Websites and services and the material published on them. These works are protected by copyright laws and treaties worldwide, and all these rights are protected by law. Users may not use any part of the material contained in the Website for commercial purposes without obtaining a license from Us or Our' licensors.",
      },
      {
        number: '7.2',
        content:
          "If the User prints, copies, or downloads part of the Website that violates these Terms & Conditions, the User's right to use the Website and all associated services will be terminated immediately. The User must destroy the copy of materials that the User has made.",
      },
    ],
  },
  {
    section: 'Link of the Website',
    subsections: [
      {
        number: '8.1',
        content:
          "User can make a link to Website's homepage, as long as the User does so in a fair and legal manner and does not harm Our reputation or take advantage of it. However, the User must not create a link in such a way as to give the impression of any form of association, approval, or endorsement on our part while it is not the real case.",
      },
      {
        number: '8.2',
        content: 'We reserve the right to revoke linking permissions without notice.',
      },
      {
        number: '8.3',
        content:
          "If Website has links to other sites and resources provided by third parties, those links are solely for User information. We have no control over the content of such sites or resources, and is not responsible for them or for any loss or damage that may arise from the User's use of the links",
      },
    ],
  },
  {
    section: 'Violations, Suspensions, and Terminations',
    subsections: [
      {
        number: '9.1',
        content:
          "If the User violates these Terms & Conditions, We may take the following actions as deemed appropriate in the circumstances: Immediate, temporary, or permanent withdrawal of the User's right to use the Website, Provide warnings to the User, File a lawsuit against the User, or Disclosing User information to the relevant law enforcement officers.",
      },
      {
        number: '9.2',
        content:
          'The User agrees to indemnify us against all costs, losses, damages, expenses, and liabilities (including, but not limited to, reasonable administrative and legal fees) suffered, incurred, or paid by us as a result of a breach of these Terms & Conditions and Privacy Policy.',
      },
    ],
  },
  {
    section: 'Jurisdiction and Applicable Law',
    subsections: [
      {
        number: '10.1',
        content:
          "Jakarta Barat District Court, Indonesia, will have exclusive jurisdiction over any claims arising out of or related to this Terms & Conditions and User's use of Our services. However, we have the right to file a claim against the User for such matters in the User's country of residence or any other country where relevant. These Terms & Conditions, and any dispute or claim arising out of or in connection with or its subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the laws of Republic of Indonesia.",
      },
      {
        number: '10.2',
        content:
          'If a competent court decides that any provision of these Terms & Conditions or Privacy Policy is invalid, unlawful, or unenforceable to some extent, that term will, to the extent determined, be removed from the the entirety of the terms, which will remain in effect to the fullest extent permitted by law.',
      },
    ],
  },
  {
    section: 'Other Terms',
    subsections: [
      {
        number: '11.1',
        content:
          'User is not allowed to use the Website by using a false identity or belonging to another person.',
      },
      {
        number: '11.2',
        content: 'User is not allowed to use the Website to carry out illegal activities.',
      },
      {
        number: '11.3',
        content:
          'User is not allowed to collect and store data and personal information belonging to other Users.',
      },
      {
        number: '11.4',
        content:
          'User is not allowed to collect and store the results of a study conducted by Us without Our consent.',
      },
      {
        number: '11.5',
        content:
          'User is not allowed to use Website in any way that violates applicable local, national or international laws or regulations.',
      },
      {
        number: '11.6',
        content:
          'User is not allowed to abuse Website by introducing viruses, Trojans, or other harmful things.',
      },
      {
        number: '11.7',
        content:
          'User is not allowed to attempt to gain unauthorized access to the Website, the servers on which the Website is stored, or the servers, computers, or databases connected to the Website.',
      },
      {
        number: '11.8',
        content:
          'User is not allowed to attack our Website via denial-of-service attacks or distributed denial-of-service attacks.',
      },
      {
        number: '11.9',
        content:
          'User is not allowed to send, or cause delivery, unsolicited or unauthorized advertising or promotional materials or other similar forms of solicitation (spam).',
      },
      {
        number: '11.10',
        content:
          "We are ​​not responsible to the User for any loss or damage resulting from denial-of-service attacks, viruses, or other harmful things that may harm computer equipment, computer programs, data, or other proprietary materials as a result of the use of the Websites or the downloading of any posted material in it, or in any Website's services associated with it.",
      },
    ],
  },
]

export default termsAndCondition
